<div class="subheader" [attr.data-omni-qa]="omniQaTag">
  <ng-content></ng-content>
</div>
